import { useProcessIdOnSingleProcessPage } from "components/CustomGridItems/LotInfoBar/lotInfoUtils";
import {
  useIsTimelineExpanded,
  useRejectCountTimelineSegments,
} from "components/Dashboard/HubletView/SingleTimeline/singleTimelineStore";
import { TAGHIGHLIGHT_BACKDROP_HEIGHT } from "components/Dashboard/HubletView/SingleTimeline/TagHighlightTimelineBackdrop";
import { SERVER_NAMES } from "components/Nav/Drawers/RightDrawer/FlightDebugger/SERVER_NAMES";
import { useSelector } from "store/useSelector";
import { useTimeAxisContext } from "utils/customHooks/genericHooks";
import { getTimelineOffsetY } from "./skuOperatorTimelineUtils";
import { safariOffset } from "./safariOffset";
import { RejectCountCanvas } from "./RejectCountCanvas";

/**
 * Display reject count segments in the timeline with tooltips on hover
 */

export function RejectCountSegments({ order }: { order: number }) {
  const [isTimelineExpanded] = useIsTimelineExpanded();
  const processId = useProcessIdOnSingleProcessPage();
  const rejectCountTimelineSegments = useRejectCountTimelineSegments();
  const timelineOffsetY = getTimelineOffsetY(order);
  const { xLeft, xRight, scaleTime } = useTimeAxisContext();
  const visibleRange = useSelector(s => s.legacy.visibleRange);
  const x0 = visibleRange?.ge ? scaleTime(visibleRange.ge) || 0 : xLeft;
  const x1 = visibleRange?.lt
    ? scaleTime(visibleRange.lt) || 0
    : Math.min(scaleTime(Date.now()), xRight);
  const rectLeft = Math.max(x0, xLeft);
  const rectRight = Math.min(x1, xRight);
  const rectWidth = rectRight - rectLeft;

  return (
    <>
      <foreignObject
        x={rectLeft + 0.5}
        y={timelineOffsetY + safariOffset}
        height={TAGHIGHLIGHT_BACKDROP_HEIGHT}
        width={Math.max(0, rectWidth - 0.5)}
        data-server-names={[SERVER_NAMES.midgardDataDumpRows]}
        className={`reject-count-segments`}
      >
        <RejectCountCanvas
          width={rectWidth}
          isTimelineExpanded={isTimelineExpanded}
          rejectCountSegments={
            processId ? rejectCountTimelineSegments[processId] || [] : []
          }
          processId={processId || ""}
        />
      </foreignObject>
    </>
  );
}
